import React, { useEffect, useRef } from 'react';
import './HeroSection.css';

const HeroSection: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log('Video autoplay failed:', error);
      });
    }
  }, []);

  return (
    <section className="hero-section">
      <div className="video-background">
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          poster="/assets/video-poster.jpg"
        >
          <source src="/assets/onboarding.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div>
      </div>
      
      <div className="hero-content">
        <h1 className="hero-title">
          Transform Your Selfies<br />
          <span className="gradient-text">Into Stunning AI Portraits</span>
        </h1>
        
        <p className="hero-subtitle">
          56+ artistic styles. Professional quality. Ready in minutes.
        </p>
        
        <div className="cta-buttons">
          <a href="https://apps.apple.com/us/app/getaiportrait/id6751330412" className="cta-primary">
            <img src="/assets/app-store-badge.svg" alt="Download on the App Store" />
          </a>
          <div className="cta-secondary cta-coming-soon" style={{position: 'relative', opacity: 0.6, cursor: 'not-allowed'}}>
            <img src="/assets/google-play-badge.svg" alt="Get it on Google Play" style={{filter: 'grayscale(100%)'}} />
            <span style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: '#FF6B35',
              color: 'white',
              padding: '4px 12px',
              borderRadius: '12px',
              fontSize: '12px',
              fontWeight: '600',
              whiteSpace: 'nowrap'
            }}>COMING SOON</span>
          </div>
        </div>
        
        <div className="trust-indicators">
          <div className="indicator">
            <span className="indicator-value">4.8★</span>
            <span className="indicator-label">App Store Rating</span>
          </div>
          <div className="indicator">
            <span className="indicator-value">50K+</span>
            <span className="indicator-label">Happy Users</span>
          </div>
          <div className="indicator">
            <span className="indicator-value">1M+</span>
            <span className="indicator-label">Portraits Created</span>
          </div>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <span>Scroll to explore</span>
        <svg className="scroll-arrow" width="24" height="24" viewBox="0 0 24 24">
          <path d="M12 5v14M5 12l7 7 7-7" stroke="currentColor" strokeWidth="2" fill="none"/>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;